<div class="centerPadded divExpertOpinionHeader" id="divExpertOpinionHeader">
  <div class="expertOpinionHeader" [ngStyle]="{'background-image': 'url(' + urlImage + ')'}">
    {{expertOpinionHeaderStrategyTitle}}
  </div>
</div>